<div class="modal-header">
    <span class="application-title modal-title" id="modal-title">Release notes</span>
    <button type="button" class="btn-close" aria-describedby="modal-title" (click)="dismiss()" aria-label="Stäng modal"></button>
</div>
<div class="modal-body">
    @if(releaseNotes) {
    <div [innerHtml]="releaseNotes" class="body"></div>
    }
</div>
<div class="modal-footer" style="justify-content: space-between !important">
    <button type="button" class="btn btn-link" (click)="close()">{{ lang.GetValue('MapMenu.Close') }}</button>
</div>
